import { useLocation } from 'react-router-dom';
import './ValidateQRComponent.css';
import { resolveSponsorImage } from '../../utils/sponsorMedia';

const formatDate = (value) => value ? new Date(`${value}T00:00:00`).toLocaleDateString('es-ES') : null;

function ValidateQRComponent() {
  const { state } = useLocation();
  const { qrImage, sponsor } = state || {};
  if (!qrImage || !sponsor) return <div className="qr-validate-container">No hay un QR activo. Abre un descuento y pulsa “Usar descuento”.</div>;

  return (
    <main className="qr-validate-container">
      <h1 className="qr-code-header">Mi QR de fallero</h1>
      <h2>{sponsor.name}</h2>
      <p>{sponsor.promotion}</p>
      {sponsor.logo && <img src={resolveSponsorImage(sponsor.logo)} alt={`Logo de ${sponsor.name}`} className="sponsor-logo" />}
      <div className="qr-code-container"><img src={qrImage} alt="Código QR temporal del fallero" className="qr-image" /></div>
      <p className="valid-message">Enseña este QR en el establecimiento.</p>
      <p>Se renueva al volver a pulsar “Usar descuento” y caduca en 5 minutos.</p>
      {(sponsor.startDate || sponsor.endDate) && <p>Validez: {formatDate(sponsor.startDate) || 'actual'} – {formatDate(sponsor.endDate) || 'sin fecha fin'}</p>}
      {sponsor.conditions && <p><strong>Condiciones:</strong> {sponsor.conditions}</p>}
    </main>
  );
}

export default ValidateQRComponent;
